<template>
	<div class="serBrand" style="height:80%" v-if="cityList.length==0">
		<Loding></Loding>
	</div>
	<div class="serBrand" v-else>
		<!--顶部 -->
		<div class="nav">
			<span></span>
			<span>找厂家</span>
			<span></span>
		</div>
		<van-tabs v-model="active" class="imgtu">
			<van-tab>
				<div slot="title">
					<div @click="dianjiping(0)">
						<img src="../../assets/tupian/1@2x.png" alt="">
						<p>全部</p>
					</div>
				</div>
			</van-tab>
			<van-tab v-for="item in baderlist" :key="item">
				<div slot="title">
					<div @click="dianjiping(item.id)">

						<img :src="'https://backstage.jbj-china.com.cn/uploads'+item.image" alt="">
						<p>{{item.title}}</p>
					</div>
				</div>
			</van-tab>
		</van-tabs>
		<div class="serBrand-list">
			<van-index-bar :sticky="false" highlight-color="#f1452f" id="serBrand" :index-list="indexList">
				<van-index-anchor class="serBrand_cell" v-for="(item,index) in brandList" :key="index" :index="index" v-model="active">
					<span class="color_f145">{{index}}</span>
					<van-cell v-for="(citem,cindex) in item" :key="cindex" @click="toBrand(citem.id)">
						<div slot="title">
							<img :src="citem.imag | handleUrl" alt="">
						</div>
						<div slot="default" class="anchor_right">{{citem.name}}</div>
					</van-cell>
				</van-index-anchor>
				<div class="dianji"></div>
			</van-index-bar>
		</div>

		<Footbar></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar'
	import Loding from '@/components/loding'

	export default {
		data() {
			return {
				baderlist: [],
				ture: true,
				index: 0,
				active: 0,
				activeName: 'a',
				FirstPin: '',
				indexList: '', //右边id
				cityList: [],
				cityNameList: [],
				firstName: {},
				firstNamea: {},
				brandList: {},
				hotList: [],
			}
		},
		components: {
			Footbar,
			Loding
		},
		created() {
			this.getData(0);
			this.dianshang();
		},
		computed: {},
		methods: {
			dianjiping(e) {
				this.indexList = 1,
				this.FirstPin = 1,
				this.getData(e)
			},
			dianshang() {
				this.$axios.post(baseUrl + '/mobile/Brand/brandCategory').then((res) => {
					if (res.data.code == 2) {
						this.baderlist = res.data.data;
					}
				}).catch((err) => {
					console.log(err);
				});

			},
			getData(id) {
				this.$axios.post(baseUrl + '/mobile/Brand/brand', {
					id: id
				}).then((res) => {
					if (res.data.code == 2) {
						this.firstName = {},
						this.cityNameList = [],
						this.FirstPin = res.data.data.zm;
						this.indexList =  res.data.data.zm;
						this.cityList = res.data.data.brand;
						for (let p in this.cityList) {
							this.cityNameList.push({
								name: this.cityList[p].title,
								id: this.cityList[p].id,
								imag: this.cityList[p].brang_icon,

							})
						};
						let pinyin = require('js-pinyin')
						pinyin.setOptions({
							checkPolyphone: false,
							charCase: 0
						});
						this.FirstPin.forEach((item) => {
							//对象
							this.firstName[item] = [];
							this.cityNameList.forEach((el) => {
								let first = pinyin.getFullChars(el.name).substring(0, 1);
								//名称abc
								if (first == item) {
									this.firstName[item].push({
										name: el.name,
										id: el.id,
										imag: el.imag
									})
								}
							})
						});
						this.brandList = this.firstName;
					}
				}).catch((err) => {});
			},
			//跳转详情
			toBrand(id) {
				this.$router.push({
					path: '/BrandDetail',
					query: {
						id: id
					}
				})
			}
		},
		//缓存页面
		beforeRouteLeave(to, from, next) {
			// 设置下一个路由的 meta
			to.meta.keepAlive = true; // B 跳转到 A 时，让 A 缓存，即不刷新（代码写在B页面）
			next();
		},
		// watch: {
		//   '$route'(to, from) {
		//     console.log(111111)
		//     if (to.name === 'Brand') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
		//       let changjiaY = this.$store.state.changY;
		//       console.log(changjiaY)
		//       //把在vuex里面的位置存入
		//       document.documentElement.scrollTop = changjiaY

		//     } 
		//   }

		// },
		// beforeRouteLeave(to, from, next) {
		//   //获取滚动条的高度
		//   let position = document.body.scrollTop||document.documentElement.scrollTop; 
		//   console.log(position)
		//   //离开路由存起来
		//   if (position == null) position = 0
		//   this.$store.commit('changjiaY', position) //离开路由时把位置存起来
		//   next()
		// },
	}
</script>

<style scoped>
	@import "serBrand.css";

	.pingpai {
		overflow-x: auto;
		display: flex;
		height: 4.8rem;


	}

	.serBrand>>>.van-tabs__line {
		width: 3rem !important;
	}

	.serBrand .serBrand-list {
		position: absolute;
		width: 100%;
		top: 9.5rem;
		bottom: 0;
		right: 0;
		left: 0;
		overflow-y: scroll;
	}

	.serBrand>>>.van-tabs__wrap--scrollable .van-tab {
		-webkit-box-flex: 0;
		-webkit-flex: 0 0 22%;
		flex: 0 0 16.6% !important;
		display: flex;
		text-align: center;
		/* padding-top: 3rem; */
	}

	.pingpai div {

		flex: 0 0 16.6%;
		text-align: center;
		color: #f1452f;
		/* margin-left: 1.2rem; */
	}

	.pingpai div::before {
		content: "";
		position: absolute;
		top: 0;
		left: 100%;
		width: 0;
		height: 100%;
		border-bottom: 2px solid #000;
		transition: 0.2s all linear;
	}

	.pingpai:hover::before {
		width: 100%;
		left: 0;
	}

	.serBrand>>>.van-index-bar__sidebar {
		position: fixed;
		top: 55%;
	}

	.pingpai button:nth-child(5) {
		margin-right: 1.3rem;
	}

	.zhanwe {
		width: 1rem;
	}

	/* div::-webkit-inner-spin-button{
      width: 0;
    } */
	div::-webkit-scrollbar {
		width: 0;
	}

	.pingpai div img {
		margin-top: 0.5rem;
		width: 40px;
		height: 40px;
	}

	.pingpai div p {
		margin: 0;
		font-size: 0.8rem;
		color: #333333;
	}




	.hezi {
		display: flex;


	}

	.dahezi>>>.van-tabs__wrap--scrollable .van-tabs__nav {
		overflow-x: hidden;
	}

	.dahezi>>>.van-tabs__wrap--scrollable .van-tab {
		flex: 0 0 16.6%;
	}

	.imgtu div img {
		width: 40px;
		position: relative;
		top: 0.8rem;
		height: 40px;
	}

	.imgtu div {
		flex: 0 0 16.6%;
		display: block;
	}

	.imgtu div p {
		margin-top: -1rem;
		z-index: 999;
	}

	.imgtu div {
		flex: 0 0 16.6%;
		display: block;
	}

	.imgtu div p {
		margin-top: -0.7rem;
		z-index: 999;
		font-size: 0.8rem;
	}

	.imgtu>>>.van-tabs__wrap--scrollable .van-tab {
		flex: 0 0 16.6% !important;
		height: 5rem;
		text-align: center !important;
		justify-content: center !important;
	}

	.imgtu>>>.an-tabs__wrap .van-tabs__wrap--scrollable .van-hairline--top-bottom {
		height: 6rem !important;
		z-index: 999;
	}

	.van-tabs {
		/* display: flex;
   flex: 0 0 16.6%; */
		/* position: fixed; */
		height: 5rem;
		z-index: 22;
	}

	.serBrand>>>.van-tabs__line {

		transition-duration: 0.08s !important;
	}


	.serBrand>>>.van-tabs--line .van-tabs__wrap {
		height: 5.5rem !important;
	}

	.serBrand>>>.serBrand_cell span:nth-child(1) {
		/* padding-top:4rem; */
	}

	.konghe {
		height: 100%;
		/* padding-top: 4rem; */
	}

	.dianji {
		padding-bottom: 3.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/serBrand/serBrand.vue